import React, { useEffect, useState } from "react";
import { Box, Typography, Snackbar, Slide, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
}

export const LoginToast = () => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const flag = sessionStorage.getItem("login_success_toast");
        if (flag === "true") {
            setOpen(true);
            sessionStorage.removeItem("login_success_toast");
        }
    }, []);

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            autoHideDuration={1000}
            onClose={handleClose}
            TransitionComponent={TransitionDown}
            sx={{
                top: { xs: 16, sm: 20 },
                right: { xs: 16, sm: 24 },
                zIndex: 99999
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 2,
                    py: 1.2,
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.12), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #e5e7eb",
                    minWidth: "250px",
                    maxWidth: "360px"
                }}
            >
                <CheckCircleIcon sx={{ color: "#10b981", fontSize: 26 }} />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#1f2937",
                        flexGrow: 1,
                        lineHeight: 1.4
                    }}
                >
                    {t("login_success") || "Đăng nhập thành công!"}
                </Typography>
                <IconButton
                    size="small"
                    onClick={handleClose}
                    sx={{ color: "#9ca3af", p: 0.5, "&:hover": { color: "#4b5563" } }}
                >
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </Box>
        </Snackbar>
    );
};

export default LoginToast;
